import { faGripDotsVertical } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Space } from "antd"

export type OverlayItem = {
  name: string
}

type Props = {
  item?: OverlayItem
}

const ItemOverlay = ({item}: Props) => {
  return <div style={{
    padding: 16,
    border: '1px solid #ddd',
    borderRadius: 5,
    backgroundColor: 'white',
    position: 'relative',
    minWidth: '250px'
  }}>
    <Space size="large"><FontAwesomeIcon icon={faGripDotsVertical} style={{ fontSize: 18 }}/>{item?.name ?? 'Item'}</Space>
  </div>
}

export default ItemOverlay